module.exports = __webpack_public_path__ + "static/media/sub-card-label-10-over.c2f65e7e.svg";